import { capitalDesignTokens, createTypedSxStyles } from '@opengov/capital-mui-theme';

// capital-mui-theme v37 gray50 token. Token not available in v36
const muiV37Gray50 = '#F8F8F8';
const muiV37Gray200 = '#DDDEDE';

export const styles = createTypedSxStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px'
  },
  title: {
    fontWeight: capitalDesignTokens.foundations.typography.fontWeight.medium
  },
  dropzoneDefault: {
    outline: 'none'
  },
  dropzoneInactive: {
    background: muiV37Gray50,
    border: `1px solid ${muiV37Gray200}`,
    borderRadius: '4px',
    padding: '8px',
    textAlign: 'center',
    cursor: 'pointer',
    transition: 'border-color 0.2s ease'
  },
  dropzoneActive: {
    background: muiV37Gray50,
    border: `1px solid ${capitalDesignTokens.semanticColors.interaction.focus}`,
    borderRadius: '4px',
    padding: '8px',
    textAlign: 'center',
    cursor: 'pointer',
    backgroundColor: capitalDesignTokens.foundations.colors.brand50
  },
  insideContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: `1px dashed ${capitalDesignTokens.foundations.colors.gray700}`,
    borderRadius: '4px',
    padding: '8px'
  },
  uploadIcon: {
    fontSize: '24px',
    color: capitalDesignTokens.foundations.colors.gray800,
    marginRight: '8px'
  },
  dropzoneText: {
    color: capitalDesignTokens.foundations.colors.gray700
  },
  selectFilesButton: {
    fontSize: capitalDesignTokens.foundations.typography.fontSize.bodyDefault,
    fontWeight: capitalDesignTokens.foundations.typography.fontWeight.normal,
    padding: 0,
    marginBottom: '3px',
    '&:hover': {
      backgroundColor: 'transparent',
      textDecoration: 'underline',
      cursor: 'pointer'
    }
  },
  fontAccessibilityWarningContainer: {
    marginTop: '4px'
  }
});
